import { get } from '@/services/FetchServices';

import { ICardTransaction, TCardTransactionFormFilters } from '@/features/cards/store/models/card.model';

import { getStaticDashboardConfig } from '@/hooks/useDashboardConfig';

import { ICursorElements } from '@/store/types/search.types';
import { filtersToQueryParameters } from '@/utils/filtersToQueryParameters';

export class CardTransactionService {
  static queryKey = 'CardTransaction';
  static getCardTransactionsById = async (
    cardId: number | undefined,
    transactionsFilters?: TCardTransactionFormFilters,
    currentCursor?: string | null,
  ): Promise<ICursorElements<ICardTransaction>> => {
    try {
      const config = getStaticDashboardConfig();
      const paramsId = cardId ? `/${cardId}` : '';
      const { paymentStatus, paymentTypes, ...rest } = transactionsFilters || {};
      const params =
        filtersToQueryParameters<Omit<TCardTransactionFormFilters, 'paymentStatus' | 'paymentTypes'>>(rest);

      if (currentCursor) params.set('cursor', currentCursor.toString());

      if (paymentStatus?.length) {
        transactionsFilters?.paymentStatus.forEach((type) => params.append('paymentStatus[]', type));
      }

      if (paymentTypes?.length) {
        transactionsFilters?.paymentTypes.forEach((type) => params.append('paymentType[]', type));
      }

      return await get(
        {
          url: `${config.api.baseUrl}/core-connect/cardtransactions${paramsId}?${params.toString()}`,
          searchParams: {
            ...Object.fromEntries(params),
            paramsId,
          },
          action: this.queryKey,
        },
        { hasCursor: true },
      );
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
